<template>
  <div>
    <div class="row mb-4">
      <div class="col-md-12">
        <router-link
          :to="{ path: '/shirt/repair/report' }"
          class="btn btn btn-info"
        >
          Report
        </router-link>
        <router-link
          :to="{ path: '/shirt/repair/overview' }"
          class="btn btn btn-info"
        >
          Overview
        </router-link>
        <router-link
          :to="{ path: '/shirt/repair/start_scan' }"
          class="btn btn btn-info"
          v-if="!isReadOnlyUser"
        >
          Start Scan
        </router-link>
        <router-link
          :to="{ path: '/shirt/repair/finished_scan' }"
          class="btn btn btn-info"
          v-if="!isReadOnlyUser"
        >
          Finished Scan
        </router-link>
      </div>
    </div>
    <br />
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isReadOnlyUser: false,
    };
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
  },
};
</script>
<style scoped>
.btn.active {
  background: var(--primary-color) !important ;
  font-weight: bold;
}
</style>
